<template>
  <q-dialog v-model="tagging">
    <q-card style="width: 320px">
      <div class="q-pa-md">
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <div class="tag-wrapper">
              <div
                class="tag-container"
                v-for="(tag, index) in tags"
                :key="tag.id"
                @click="tagHandler(tag, index)"
              >
                <div
                  class="box"
                  :style="
                    allHandler(tag.id) == 'all' ? `background:${tag.color}` : ''
                  "
                  :class="{
                    'active-tag': allHandler(tag.id) == 'all',
                    'maybe-tag': allHandler(tag.id) == 'some',
                  }"
                >
                  <transition name="component-slide">
                    <i
                      class="fas fa-check"
                      v-if="allHandler(tag.id) == 'all'"
                    ></i>
                    <i
                      class="fas fa-minus"
                      v-else-if="allHandler(tag.id) == 'some'"
                    ></i>
                  </transition>
                </div>
                <div class="tag-name selection-disable" v-text="tag.name"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" style="margin-top: 10px">
          <div class="mt-5 flex-end q-gutter-xs">
            <q-btn color="grey-7" @click="abort">CANCEL</q-btn>
            <q-btn
              :loading="loading"
              :disable="loading"
              @click="save"
              label="Save"
              type="button"
              color="positive"
            >
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script>
import axios from "../axios";
export default {
  data() {
    return {
      loading: false,
      localSelectedVehicles: [],
      tagCache: null,
    };
  },
  props: ["selection"],
  methods: {
    tagHandler(tag, index) {
      // todo : refactor
      const lastStatus = this.allHandler(tag.id);

      switch (lastStatus) {
        case "all":
          // set none
          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              vehicle.tags = vehicle.tags.filter((t) => t.id !== tag.id);
              return vehicle;
            }
          );
          break;
        case "some":
          // set all
          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              if (!vehicle.tags.find((t) => t.id == tag.id)) {
                vehicle.tags.push(tag);
              }
              return vehicle;
            }
          );
          break;
        case "none":
          // set some
          const oldVehicles = this.tagCache.filter((vehicle) => {
            return vehicle.tags.some((t) => t.id === tag.id);
          });

          if (oldVehicles.length === 0) {
            this.localSelectedVehicles = this.localSelectedVehicles.map(
              (vehicle) => {
                if (!vehicle.tags.includes(tag)) {
                  vehicle.tags.push(tag);
                }
                return vehicle;
              }
            );
            break;
          }

          this.localSelectedVehicles = this.localSelectedVehicles.map(
            (vehicle) => {
              const prevVehicle = this.tagCache.find(
                (v) => v.id === vehicle.id
              );
              if (prevVehicle.tags.some((t) => t.id === tag.id)) {
                // eskiden vardı
                if (!vehicle.tags.some((t) => t.id === tag.id)) {
                  vehicle.tags.push(tag);
                }
              } else {
                // eskiden yoktu
                vehicle.tags = vehicle.tags.filter((t) => t.id !== tag.id);
              }

              return vehicle;
            }
          );
          break;
      }
    },
    bodyHandler() {
      let body = [];
      this.localSelectedVehicles.map((item) =>
        body.push({ vehicle: item.id, tags: item.tags.map((item) => item.id) })
      );
      return body;
    },
    dataHandler() {
      let body = [];
      this.localSelectedVehicles.map((item) =>
        body.push({ vehicle: item.id, tags: item.tags })
      );
      return body;
    },
    async save() {
      try {
        this.loading = true;
        const body = await this.bodyHandler();
        const { data } = await axios.post("vehicle-tagging", body);
        const dataHandler = await this.dataHandler();
        this.$store.commit("profit/SET_VEHICLES_TAGS_CHANGED", dataHandler);
        this.$emit("clearVehicles", true);
      } finally {
        this.loading = false;
        this.tagging = false;
      }
    },
    abort() {
      this.tagging = false;
    },
    allHandler(tag_id) {
      const every = this.localSelectedVehicles.every((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      const some = this.localSelectedVehicles.some((veh) => {
        let { tags } = veh;
        return tags.some((t) => t.id === tag_id);
      });
      if (every) return "all";
      else if (some) return "some";
      else return "none";
    },
  },
  computed: {
    tags: {
      get() {
        return this.$store.state.tag.tags;
      },
      set(val) {
        this.$store.commit("tag/SET_TAGS", val);
      },
    },
    tagging: {
      get() {
        return this.$store.state.profit.tagging;
      },
      set(val) {
        this.$store.commit("profit/SET_TAG_OPERATION", val);
      },
    },
  },
  watch: {
    tagging(n, o) {
      if (n) {
        const withoutVuexErrorCopyVehicles = JSON.parse(
          JSON.stringify(this.selection)
        );
        this.localSelectedVehicles = withoutVuexErrorCopyVehicles;
        this.tagCache = withoutVuexErrorCopyVehicles;
      } else this.tagCache = null;
    },
  },
};
</script>
